import { addDoc, collection } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateExpense = async (ExpenseData, uid) => {
  try {
    const ExpenseCollection = collection(db, "Expenses");

    let schoolId = localStorage.getItem("schoolId");

    schoolId = JSON.parse(schoolId);

    ExpenseData = { ...ExpenseData, schoolId };

    const data = HelperForMetaData({
      ...ExpenseData,
      uid: uid,
    });
    await addDoc(ExpenseCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateExpense;
